import React, { useState, useEffect } from "react";
import {
  Box,
  VStack,
  Heading,
  Text,
  Button,
} from "@chakra-ui/react";
import { navy_blue, royal_blue } from "./env";

const SingleTabSessionGuard = () => {
  const [isTabActive, setIsTabActive] = useState(true);
  const [tabId] = useState(() => Math.random().toString(36).substring(2, 15));

  useEffect(() => {
    // 1. Register this tab as the active one on startup
    localStorage.setItem("active_tab_id", tabId);

    // 2. Listen to changes in localStorage from other tabs
    const handleStorageChange = (e) => {
      if (e.key === "active_tab_id") {
        const newActiveTabId = e.newValue;
        if (newActiveTabId && newActiveTabId !== tabId) {
          setIsTabActive(false);
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    // 3. Keep updating active status on focus just in case
    const handleFocus = () => {
      const currentActive = localStorage.getItem("active_tab_id");
      if (currentActive && currentActive !== tabId) {
        setIsTabActive(false);
      }
    };
    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("focus", handleFocus);
    };
  }, [tabId]);

  const handleReactivate = () => {
    localStorage.setItem("active_tab_id", tabId);
    setIsTabActive(true);
  };

  if (isTabActive) {
    return null; // Render nothing if the tab is active
  }

  // Use the exact app colors: navy_blue (#000080) and royal_blue (#4169E1)
  const primaryColor = navy_blue || "#000080";
  const hoverColor = royal_blue || "#4169E1";

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100vw"
      height="100vh"
      zIndex={999999}
      bg="rgba(0, 0, 0, 0.5)"
      backdropFilter="blur(12px)"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        p={8}
        maxW="md"
        w="90%"
        bg="white"
        borderRadius="xl"
        boxShadow="xl"
        textAlign="center"
      >
        <VStack spacing={5}>
          <VStack spacing={2}>
            <Heading size="md" color={primaryColor} fontWeight="bold">
              Session Inactive
            </Heading>
            <Text color="gray.600" fontSize="sm">
              NotesAI is running in another tab. Only one active window is allowed at a time to protect your data.
            </Text>
          </VStack>
          <Button
            bg={primaryColor}
            color="white"
            size="md"
            w="full"
            borderRadius="md"
            _hover={{
              bg: hoverColor,
            }}
            transition="background 0.2s"
            onClick={handleReactivate}
          >
            Use NotesAI Here
          </Button>
        </VStack>
      </Box>
    </Box>
  );
};

export default SingleTabSessionGuard;
